import React, { FC } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { IProps } from './SCUIStoreListDrawerContent.config';
import { Grid, TextField } from '@mui/material';
import { SCUIButton } from '../../atoms';
import Swal from 'sweetalert2';
import { OmnichannelCommand } from '../../../services/command';
import { useTranslation } from 'react-i18next';

export const SCUIStoreListDrawerContent: FC<IProps> = ({ detail, onClose, onUpdate }) => {
    const { t } = useTranslation();
    const [statusName, setStatusName] = React.useState(detail.storeStatus);
    const [storeName, setStoreName] = React.useState(detail.storeName);
    const [address, setAddress] = React.useState(detail.adress);
    const [email, setEmail] = React.useState(detail.email);
    const [phone, setPhone] = React.useState(detail.phone);
    const [storeStatus, setStoreStatus] = React.useState(detail.storeStatus);
    const _handleChangeStatus = (event: SelectChangeEvent) => {
        setStatusName(event.target.value as string);
        setStoreStatus(event.target.value);
    };

    const handleChangeStoreName = (event: any) => {
        setStoreName(event.target.value);
    };
    const handleChangeAddress = (event: any) => {
        setAddress(event.target.value);
    };
    const handleChangePhone = (event: any) => {
        setPhone(event.target.value);
    };
    const handleChangeEmail = (event: any) => {
        setEmail(event.target.value);
    };

    const updateStoreList = () => {
        Swal.fire({
            text: t('general.updateConfirmationText'),
            cancelButtonText: t('general.cancel'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('general.update'),
        }).then((result: any) => {
            if (result.isConfirmed) {
                let params: any = {};
                params.storeId = detail?.id;
                params.storeName = storeName;
                params.storePhone = phone;
                params.address = address;
                params.storeStatus = storeStatus;
                params.notificationEmailAddress = email;
                params.storeCode = detail?.storeCode;
                console.info(params);

                OmnichannelCommand.PostUpdateStoreList(params);
                onUpdate();
                console.info(onUpdate());
                Swal.fire(t('general.updated'), ' ', 'success');
            }
        });
    };

    return (
        <Grid className="designCollectiveDetailGrid">
            <Grid container sx={{ paddingTop: '2rem' }}>
                <Grid
                    size={{
                        md: 6,
                        xs: 6,
                        lg: 11
                    }}>
                    <h1 className="headtxt">
                        {t('omnichannel.storeName')}: {detail?.storeName}
                    </h1>
                </Grid>

                <Grid
                    size={{
                        md: 1,
                        xs: 1,
                        lg: 1
                    }}>
                    <CloseIcon className="svg_icons" onClick={onClose} />
                </Grid>
            </Grid>
            <Grid container sx={{ padding: '3rem' }}>
                <br />

                <Grid
                    size={{
                        md: 12,
                        xs: 12
                    }}>
                    <TextField
                        label={t('omnichannel.storeId')}
                        margin="dense"
                        id="parameterValue"
                        fullWidth
                        defaultValue={detail?.storeCode}
                        disabled
                    />
                </Grid>
                <Grid
                    size={{
                        md: 12,
                        xs: 12
                    }}>
                    <TextField
                        label={t('omnichannel.storeName')}
                        margin="dense"
                        id="parameterValue"
                        fullWidth
                        defaultValue={detail?.storeName}
                        onChange={handleChangeStoreName}
                    />
                </Grid>
                <Grid
                    size={{
                        md: 12,
                        xs: 12
                    }}>
                    <TextField
                        label={t('omnichannel.storeAddress')}
                        margin="dense"
                        id="parameterValue"
                        fullWidth
                        defaultValue={detail?.adress}
                        onChange={handleChangeAddress}
                    />
                </Grid>
                <Grid
                    size={{
                        md: 12,
                        xs: 12
                    }}>
                    <TextField
                        label={t('omnichannel.phone')}
                        margin="dense"
                        id="parameterValue"
                        fullWidth
                        defaultValue={detail?.phone}
                        onChange={handleChangePhone}
                    />
                </Grid>
                <Grid
                    size={{
                        md: 12,
                        xs: 12
                    }}>
                    <TextField
                        label={t('omnichannel.city')}
                        margin="dense"
                        id="parameterValue"
                        fullWidth
                        defaultValue={detail?.cityId}
                        disabled
                    />
                </Grid>

                <Grid
                    size={{
                        md: 12,
                        xs: 12
                    }}>
                    <TextField
                        label={t('omnichannel.districtName')}
                        margin="dense"
                        id="parameterValue"
                        fullWidth
                        defaultValue={detail?.districtId}
                        disabled
                    />
                </Grid>
                <Grid
                    size={{
                        md: 12,
                        xs: 12
                    }}>
                    <TextField
                        label={t('omnichannel.email')}
                        margin="dense"
                        id="parameterValue"
                        fullWidth
                        defaultValue={detail?.email}
                        onChange={handleChangeEmail}
                    />
                </Grid>
                <Grid
                    size={{
                        lg: 12,
                        md: 12,
                        xs: 12
                    }}>
                    <FormControl fullWidth>
                        <InputLabel id="statusSelectLabel">{t('general.status')}</InputLabel>
                        <Select
                            labelId="statusSelectLabel"
                            fullWidth
                            id="statusSelect"
                            value={statusName}
                            label="Durum"
                            onChange={_handleChangeStatus}
                            className="multiTagSelect"
                        >
                            <MenuItem value={1}>{t('general.active')}</MenuItem>
                            <MenuItem value={2}>{t('general.passive')}</MenuItem>
                        </Select>
                    </FormControl>

                    <Grid
                        size={{
                            lg: 6,
                            md: 6,
                            xs: 6
                        }}>
                        <SCUIButton
                            text={t('general.update')}
                            type="primary"
                            sizeType="fixed"
                            size={'m'}
                            buttonType="button"
                            onClick={updateStoreList}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
